// extracted by mini-css-extract-plugin
export default {"svg":"ReconnectPopup_svg__7Cm5o","body":"ReconnectPopup_body__i5I1h","mobile":"ReconnectPopup_mobile__gXT+h"};